import * as Yup from 'yup';

/** @constant {ObjectShape} - Yup Object used for validationScheme in signup procedure */
const TokenCreationScheme = Yup.object().shape({
    tokendays: Yup.number().required('Token days is required'),
});

export { TokenCreationScheme };
